import React from 'react';
import DataFiscal from '../assets/images/DataFiscal.png';

export function DataFiscalIcon(props) {
  return <img alt="Data Fiscal" {...props} src={DataFiscal} />;
}
